import { SSOConfigForBackend } from '../types/SSOSetupTypes'
import { CartUIConfigTypeForBackend } from '../types/cartUI'
import { ProgressBarData } from '@shopflo/ui'

export enum SFContextType {
  SSO = 'SSO',
  CART = 'CART',
  THANK_YOU_PAGE = 'THANK_YOU_PAGE',
  PDP = 'PDP',
  CHECKOUT = 'CHECKOUT'
}

type SSOPayloadType = SSOConfigForBackend
type CartPayloadType = CartUIConfigTypeForBackend | { progress_bar_attributes: ProgressBarData[] }

export const createUIAttributePayload = (sfContext: SFContextType, data: Record<string, unknown>) => {
  return [
    {
      channel: 'web',
      sf_context: sfContext,
      config: {
        type: sfContext,
        ...data
      }
    }
  ]
}
